interface ActionTypes {
  VERIFY_INVITE_TOKEN_START: string;
  VERIFY_INVITE_TOKEN_SUCCESS: string;
  VERIFY_INVITE_TOKEN_FAILURE: string;
}

export const WelcomeActionTypes: ActionTypes = {
  VERIFY_INVITE_TOKEN_START: '@@VERIFY_INVITE_TOKEN_START',
  VERIFY_INVITE_TOKEN_SUCCESS: '@@VERIFY_INVITE_TOKEN_SUCCESS',
  VERIFY_INVITE_TOKEN_FAILURE: '@@VERIFY_INVITE_TOKEN_FAILURE'
};

export interface WelcomeState {
  verification: 'initial' | 'verifying' | 'success' | 'fail';
  error?: string;
}
